import React from 'react';
import './Image.styles.scss';
import { ImageProps } from './Image.logic';
import FPO from '../../components/FPO/FPO';

const Image: React.FC<ImageProps> = ({
  path,
  fpo,
  size = 'box',
  className = '',
  alt = '',
}) => {
  return (
    <div className={`image-wrapper image-size-${size} ${className}`}>
      <img src={path} alt={alt} className="action-on-view action-scale-up" />
      {fpo ? <FPO /> : ''}
    </div>
  );
};

export default Image;
